import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React context
import { useSoftUIController, setLayout } from "context";
import { MINI_SIDENAV_WIDTH, PORTAL_HEADER_HEIGHT, SIDENAV_WIDTH } from "cxfcomponents/portalShell";
import "./portalPage.css";

function DashboardLayout({ children, flush = false }) {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();
  const isPortalListPage = /^\/(?:workspace\/(?:flows|connectors|integrations|schedules)|administration\/(?:users|roles-and-permissions|credential-management))\/?$/.test(pathname);
  const isPortalSurfacePage = /^\/(?:workspace\/(?:flows|connectors|integrations|schedules|logs)(?:\/|$)|administration\/(?:users|roles-and-permissions|credential-management)(?:\/|$)|(?:flow|connector|integration|schedule|credential)\/|account\/users\/profile-overview(?:\/|$)|home\/profile\/?$)/.test(pathname);

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <SoftBox
      className={isPortalSurfacePage ? `portal-surface-layout ${isPortalListPage ? "portal-list-layout" : pathname === "/workspace/logs" ? "portal-logs-layout" : "portal-detail-layout"} ${pathname.startsWith("/account/users/profile-overview") || pathname === "/home/profile" ? "portal-profile-layout" : ""}` : undefined}
      sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
        padding: flush || isPortalSurfacePage ? 0 : pathname === "/home" ? "20px" : "26px 24px 8px",
        position: isPortalSurfacePage ? "fixed" : "relative",
        display: "flex",
        flexDirection: "column",
        top: isPortalSurfacePage ? pxToRem(PORTAL_HEADER_HEIGHT) : "auto",
        right: isPortalSurfacePage ? 0 : "auto",
        bottom: isPortalSurfacePage ? 0 : "auto",
        left: isPortalSurfacePage ? 0 : "auto",
        marginTop: isPortalSurfacePage ? 0 : pxToRem(PORTAL_HEADER_HEIGHT),
        minHeight: isPortalSurfacePage ? 0 : `calc(100vh - ${PORTAL_HEADER_HEIGHT}px)`,
        boxShadow: "none !important",
        overflowX: "hidden",
        overflowY: isPortalSurfacePage ? "auto" : "hidden",
        borderRadius: flush || isPortalSurfacePage ? "0 !important" : "8px !important",
        ...(isPortalSurfacePage && {
          backgroundColor: "var(--portal-canvas-bg)",
        }),
        [breakpoints.down("sm")]: {
          paddingLeft: flush || isPortalSurfacePage ? 0 : pxToRem(16),
          paddingRight: flush || isPortalSurfacePage ? 0 : pxToRem(16)
        },
        [breakpoints.up("xl")]: {
          ...(isPortalSurfacePage
            ? { left: pxToRem(miniSidenav ? MINI_SIDENAV_WIDTH : SIDENAV_WIDTH), marginLeft: 0 }
            : { marginLeft: pxToRem(miniSidenav ? MINI_SIDENAV_WIDTH : SIDENAV_WIDTH) }),
          transition: transitions.create(["left", "margin-left", "margin-right"], {
            easing: transitions.easing.easeInOut,
            duration: transitions.duration.standard
          })
        }
      })}
    >
      {children}
    </SoftBox>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
  flush: PropTypes.bool
};

export default DashboardLayout;
